/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Portals_Sync_Compare_HintInputs */

const cs_portals_sync_compare_hint = /** @type {(inputs: Portals_Sync_Compare_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Co ${i?.name} očekává oproti poslednímu známému stavu na každém portálu. Ověření obnoví stav po portálech (API, feed, nebo bez kontroly).`)
};

const en_portals_sync_compare_hint = /** @type {(inputs: Portals_Sync_Compare_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What ${i?.name} expects versus the last known state on each portal. Verify refreshes per portal (API check, feed membership, or unsupported).`)
};

/**
* | output |
* | --- |
* | "What {name} expects versus the last known state on each portal. Verify refreshes per portal (API check, feed membership, or unsupported)." |
*
* @param {Portals_Sync_Compare_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_compare_hint = /** @type {((inputs: Portals_Sync_Compare_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Compare_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_compare_hint(inputs)
	return cs_portals_sync_compare_hint(inputs)
});